const BASE_URL = {
    DEV: 'http://apple.leisureq.co.kr',
    PRODUCTION: 'https://b2b.api.leisureq.io'
};

export { BASE_URL }


// WEBPACK FOOTER //
// ./src/api/enum/ApiPath.js